import { Helmet } from "react-helmet-async";

const SITE = "https://markiti.co.ke"; // change if the domain differs

export default function Seo({ title, description, path = "/" }) {
  const url = SITE + path;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}